import { render, staticRenderFns } from "./NavPage.vue?vue&type=template&id=0005ef66&"
import script from "./NavPage.vue?vue&type=script&lang=js&"
export * from "./NavPage.vue?vue&type=script&lang=js&"
import style0 from "./NavPage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports